import { cn } from 'src/lib/utils';
import { portalDs } from 'src/components/portal-design-system';
import type { IoViewMode } from '../../utils/io-view-preference';

interface IoViewToggleProps {
  value: IoViewMode;
  onChange: (mode: IoViewMode) => void;
}

const OPTIONS: { id: IoViewMode; label: string }[] = [
  { id: 'boldsign', label: 'BoldSign' },
  { id: 'docusign', label: 'DocuSign' },
];

/** Temporary full-bleed strip while both signing providers are visible. */
const FULL_BLEED_BAR =
  'flex w-[calc(100%+2rem)] -mx-4 -mt-4 items-center rounded-none px-4 py-2 md:-mx-6 md:-mt-6 md:w-[calc(100%+3rem)] md:px-6 lg:-mx-8 lg:-mt-8 lg:w-[calc(100%+4rem)] lg:px-8';

export function IoViewToggle({ value, onChange }: IoViewToggleProps) {
  return (
    <div
      className={cn(portalDs.segmentGroup, FULL_BLEED_BAR)}
      role="group"
      aria-label="Insertion order view"
    >
      {OPTIONS.map((option) => (
        <button
          key={option.id}
          type="button"
          className={cn(portalDs.segment, value === option.id && portalDs.segmentActive)}
          onClick={() => onChange(option.id)}
          aria-pressed={value === option.id}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
